export const HEADER_LINKS = [
  { href: '/dashboard', title: 'Dashboard' },
  { href: '/bridge', title: 'Bridge' },
  { href: '/staking', title: '🔥 Staking' },
  { title: 'Farm' },
  { title: 'Swap' },
  { title: 'Vote' },
]
